import React, { useState } from 'react';
import { Input } from "@/components/ui/input";
import { WhatsAppInput } from "@/components/ui/WhatsAppInput";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { LeadFormData } from "@/types/lead";
import { validateName, validateWhatsApp } from "@/utils/formValidation";
import { MessageCircle } from "lucide-react";

interface PersonalInfoFormProps {
  formData: LeadFormData;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => void | Promise<void>;
  isSubmitting: boolean;
}

export const PersonalInfoForm: React.FC<PersonalInfoFormProps> = ({
  formData,
  onChange,
  onSubmit,
  isSubmitting
}) => {
  const [nameError, setNameError] = useState<string | undefined>();
  const [isWhatsAppValid, setIsWhatsAppValid] = useState(false);

  const handleNameBlur = (value: string) => {
    const v = validateName(value);
    setNameError(v.isValid ? undefined : v.errors[0]);
  };

  const isNameValid = validateName(formData.name).isValid;
  const canSubmit = isNameValid && isWhatsAppValid && !isSubmitting;

  return (
    <form onSubmit={onSubmit}>
      <div className="space-y-4">
        <div className="grid grid-cols-1 gap-4">
          <div className="space-y-2">
            <Label htmlFor="name">Nome completo</Label>
            <Input
              id="name"
              name="name"
              value={formData.name}
              onChange={onChange}
              onBlur={(e) => handleNameBlur(e.target.value)}
              placeholder="Digite seu nome completo"
              required
              className={`min-h-[44px] ${nameError ? 'border-red-500 focus:border-red-500' : ''}`}
              autoComplete="name"
            />
            {nameError && (
              <p className="text-sm text-red-600 mt-1">{nameError}</p>
            )}
          </div>

          <WhatsAppInput
            id="whatsapp"
            name="whatsapp"
            value={formData.whatsapp}
            onChange={(masked) => {
              const event = {
                target: { name: 'whatsapp', value: masked },
              } as React.ChangeEvent<HTMLInputElement>;
              onChange(event);
            }}
            onValidChange={setIsWhatsAppValid}
            required
          />
        </div>

        <div className="flex justify-end pt-4">
          <Button
            type="submit"
            disabled={!canSubmit}
            className="w-full min-h-[48px] bg-[hsl(142,72%,45%)] hover:bg-[hsl(142,72%,38%)] text-white font-semibold text-base"
          >
            <MessageCircle className="w-5 h-5 mr-2" />
            {isSubmitting ? 'Processando...' : 'Enviar Mensagem'}
          </Button>
        </div>
      </div>
    </form>
  );
};
